/**
 * Created by juyang on 2017/9/19.
 */
/**
 * 组件基类
 * @ignore
 * @module ContainerManager
 */
'use strict';
define(['../map/Map', '../utils/CommonUtil', './Class', '../g2'], function(Map, util, Class, g2) {

    /**
     * 组件初始化构造方法
     * @ignore
     * @constructor
     * @classdesc 组件基类
     * @alias G.base.ContainerManager
     * @param {Object} options - 必填，构造参数对象
     * @returns {Class} 实例化对象
     */
    var ContainerManager = function(opt) {
        Class.setOptions(this, opt)

    }
    ContainerManager.prototype = {

        options: {},
        /**
         * 添加控件到地图
         * @method
         * @memberOf G.base.ContainerManager.prototype
         * @param map
         * @returns {ContainerManager}
         */
        addTo: function(map) {
            this.remove();
            this.options.gmap = map;
            var container = this._fcontainer = this.onAdd(map),
                pos = this.getPosition();

            if (Object.prototype.toString.call(pos) === '[object String]') {
                var corner = map._controlCorners[pos];
                $(corner).append($(container))
            } else {
                var corner = map._controlCorners['drift'];
                $(corner).append($(container))
                if (pos && Object.prototype.toString.call(pos) === '[object Object]' && !$.isEmptyObject(pos)) {
                    $(container).css(pos);
                    $(container).css({ 'position': 'absolute' });
                }
                $(container).css({ 'pointer-events': 'auto' });
                $(container).addClass('gs-container-subdrift')
            }

            if (this.created) {
                this.created();
            }


            return this;
        },
        /**
         * 移除控件
         * @method
         * @memberOf G.base.ContainerManager.prototype
         */
        remove: function() {

            if (!this.options.gmap) {
                return this;
            }

            jQuery(this._fcontainer).remove();

            if (this.onRemove) {
                this.onRemove(this.options.gmap);
            }

            this.options.gmap = null;

            return this;
        },

        constructor: ContainerManager,
        /**
         * 获取控件的位置信息
         * @method
         * @memberOf G.base.ContainerManager.prototype
         */
        getPosition: function() {
            return this.options.position;
        },
        /**
         * 设置控件的位置信息
         * @method
         * @memberOf G.base.ContainerManager.prototype
         * @param position 重新设置控件的位置
         */
        setPosition: function(position) {
            jQuery(this._fcontainer).remove();
            if (this.onRemove) {
                this.onRemove(this.options.gmap);
            }
            this.options.position = position;
            this.addTo(this.options.gmap);
        },
        /**
         *添加控件时触发的方法
         * @method
         * @memberOf G.base.ContainerManager.prototype
         */
        onAdd: function() {
            var container = document.createElement('div');
            if (this.options.id) {
                container.id = this.options.id;
            }
            if (this.options.className) {
                container.className = this.options.className;
            }
            this.container = container
            return this.container;
        },

        getFontainer: function() {
            return this._fcontainer;
        },

        getID: function() {
            var id = this.options ? this.options : this.options.id;
            id = id || ctrl.id
            if (!id) id = 'ctr' + util.stamp(this);
            return id;
        },


    }


    Map.include({


        /**
         * 添加控件
         * @method
         * @memberOf G.Map.prototype
         * @param control {Object} 必填
         */
        addControl: function(control) {
            if (control instanceof G.base.ControlBase) {
                this._controls.push(control);
                var id = control.getID ? control.getID() : 'ctr' + util.stamp(control);
                if (!id) {
                    throw (new Error('参数类型错误！'));
                }
                control.addTo ? control.addTo(this) : control.onAdd();
                return this;
            } else {
                return g2.carto.Map.prototype.addControl.call(this, control);
            }
        },
        /**
         * 移除控件
         * @method
         * @memberOf G.Map.prototype
         * @param control {Object} 必填
         */
        removeControl: function(ctrl) {
            if (ctrl instanceof G.base.ControlBase) {
                var flag = false;
                for (var i = this._controls.length - 1; i >= 0; i--) {
                    var control = this._controls[i];
                    if (control === ctrl || control.id === ctrl) {
                        control.remove ? control.remove() : control.onRemove();
                        this._controls.splice(i, 1);
                        flag = true;
                        break;
                    }
                }
                return flag;
            } else {
                return g2.carto.Map.prototype.removeControl.call(this, ctrl);
            }
        },

        /**
         * 根据id获取控件
         * @method
         * @memberOf G.Map.prototype
         * @param id {String} 必填，控件id
         * @returns {Object}
         */
        getControlById: function(id) {
            var len = this._controls.length;
            var control = null;
            for (var i = 0; i < len; i++) {
                var ctrl = this._controls[i];
                if (ctrl.id === id) {
                    control = ctrl;
                    break;
                }
            }
            return control;
        },

        _initControlPos: function() {

            var corners = this._controlCorners = {};
            var mapDiv = jQuery('#' + this.id);
            var mapParent = mapDiv //.parent();
            mapParent.append('<div class="Corners"></div>')
            var Corners = mapParent.find('.Corners').last();
            Corners.css({
                'position': 'absolute',
                'width': '100%',
                'height': '100%'
            });
            this._setContainerParentStyles(Corners[0], mapDiv[0]);
            var self = this;
            // window.onresize = function () {
            //     self._setContainerParentStyles(Corners[0], mapDiv[0]);
            // }

            function createCorner(vSide, hSide) {
                var className = 'gs-container-' + vSide + hSide;
                Corners.append('<div class="' + className + '"></div>')
                corners[vSide + hSide] = (Corners.find('.' + className))[0];
            }

            function _initDriftPos() {
                Corners.append('<div class="gs-container-drift"></div>')
                var Drift = mapParent.find('.gs-container-drift')
                corners['drift'] = Drift[0];
            }

            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
            _initDriftPos();

        },

        _clearPos: function() {

            jQuery('#' + this.id + " .Corners").remove();
            jQuery('#' + this.id + " .Drift").remove();
        },

        _setContainerParentStyles: function(parent, mapDiv) {
            console.log(parent);
            parent.style['top'] = 0 + 'px';
            parent.style['left'] = 0 + 'px';
            // parent.style['left'] = (mapDiv.offsetLeft + mapDiv.scrollLeft) + 'px';
            // parent.style['width'] = mapDiv.offsetWidth + 'px';
            // parent.style['height'] = mapDiv.offsetHeight + 'px';

            // parent.style['position'] = 'absolute';
            // parent.style['pointer-events'] = 'none';
        },

    })

    Map.addInitHook(function() {
        this._controls = [];
        /**
         * 2019年10月21日9:41:37 保留控件容器的初始化
         */
        if (this.options.initControlContainer === true) {
            if (this._initControlPos) this._initControlPos();
        }
    })


    return ContainerManager;

})